import { SearchCheck, ClipboardList, Wrench } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: SearchCheck,
    title: "Inspect & Measure",
    desc: "Free on-site inspection. We laser-measure the roofline, check fascia, grading and foundation, and show you photos of every problem spot.",
  },
  {
    n: "02",
    icon: ClipboardList,
    title: "Straight-Quote Pricing",
    desc: "One written price, itemized by material and labor. No upsells, no 'today-only' pressure — the quote is good for 30 days.",
  },
  {
    n: "03",
    icon: Wrench,
    title: "Install & Shield",
    desc: "Most gutter systems install in a single day. We haul every scrap, magnet-sweep the yard, and back the work with a 25-year warranty.",
  },
];

export const Process = () => (
  <section id="process" className="border-t border-white/10 bg-ink2/50 py-20 lg:py-32" data-testid="process-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-orange-500" />
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-orange-500">
            How It Works
          </p>
        </div>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
          Three Steps. <span className="text-orange-500">Zero Leaks.</span>
        </h2>
      </Reveal>
      <div className="relative mt-14">
        <div
          className="absolute left-[16%] right-[16%] top-10 hidden h-px bg-gradient-to-r from-orange-500/50 via-orange-500/20 to-orange-500/50 md:block"
          aria-hidden="true"
        />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.12}>
              <div
                className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-ink p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-orange-500/40 sm:p-8"
                data-testid={`process-step-${i + 1}`}
              >
                <p className="font-mono text-[10px] font-bold uppercase tracking-[0.3em] text-slate-500">
                  Step <span className="text-orange-500">/ {step.n}</span>
                </p>
                <span className="pointer-events-none absolute -right-3 -top-6 font-display text-8xl font-black text-white/5">
                  {step.n}
                </span>
                <span className="relative mt-5 flex h-12 w-12 items-center justify-center rounded-xl bg-orange-500/10 ring-1 ring-orange-500/30">
                  <step.icon className="h-6 w-6 text-orange-500" />
                </span>
                <h3 className="mt-6 font-display text-2xl font-bold uppercase text-white sm:text-3xl">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {step.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
